function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref =
/*#__PURE__*/
React.createElement("defs", null, React.createElement("path", {
  id: "icon-edit_svg__a",
  d: "M22 12.026v11a1 1 0 01-1 1H1a1 1 0 01-1-1v-20a1 1 0 011-1h11a1 1 0 010 2H2v18h18v-10a1 1 0 012 0zm-11.097-.49l9.535-9.534c.375 0 .926.07 1.21.375.3.32.373.85.376 1.21l-9.535 9.536-2.114.529.528-2.115zm13.045-7.245c.012-.042.035-.078.042-.123.028-.196.244-1.956-.882-3.157C21.956-.224 20.07.006 19.858.036c-.04.006-.072.029-.11.039a.917.917 0 00-.188.067.935.935 0 00-.169.112c-.032.025-.069.036-.098.065l-10 10c-.017.017-.023.04-.039.058a.969.969 0 00-.108.164.97.97 0 00-.087.18c-.007.023-.024.04-.029.063l-1 4a.997.997 0 001.213 1.213l4-1.001c.022-.006.04-.022.061-.03a.958.958 0 00.18-.085c.06-.034.116-.066.166-.11.018-.016.04-.021.057-.038l10-10c.026-.026.036-.06.058-.088a.996.996 0 00.13-.194c.024-.052.038-.105.053-.16z"
}));

var _ref2 =
/*#__PURE__*/
React.createElement("use", {
  fillRule: "evenodd",
  xlinkHref: "#icon-edit_svg__a"
});

var SvgIconEdit = function SvgIconEdit(props) {
  return React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em"
  }, props), _ref, _ref2);
};

export default SvgIconEdit;